import Select from "react-select";

const MenopauseFormFields = ({ formData, setFormData }) => {
  const customSelectStyles = {
    control: (provided) => ({ ...provided, minHeight: "50px" }),
    singleValue: (provided) => ({ ...provided, lineHeight: "50px" }),
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (option, { name }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: option ? option.value : "",
    }));
  };

  return (
    <div className="mb-3">
      {/* Date */}
      <div className="mb-3">
        <label className="form-label">Date<span style={{ color: "red" }}>*</span></label>
        <input
          type="date"
          className="form-control"
          name="menopause_date"
          value={formData.menopause_date}
          onChange={handleInputChange}
          max={new Date().toISOString().split("T")[0]}
          required
        />
      </div>

      {/* Age */}
      <div className="mb-3">
        <label className="form-label">Age of First Menstruation<span style={{ color: "red" }}>*</span></label>
        <Select
          name="age_first_m"
          options={[...Array(91).keys()].map((age) => ({
            value: String(age + 10),
            label: String(age + 10),
          }))}
          value={
            formData.age_first_m
              ? { value: formData.age_first_m, label: formData.age_first_m }
              : null
          }
          onChange={handleSelectChange}
          styles={customSelectStyles}
          placeholder="Select Age"
          required
        />
      </div>

      {/* Menstruation */}
      <div className="mb-3">
        <label className="form-label">Menstruation<span style={{ color: "red" }}>*</span></label>
        <Select
          name="menstruation"
          options={[
            { value: "Regular", label: "Regular" },
            { value: "Irregular", label: "Irregular" },
            { value: "Stopped", label: "Stopped" },
          ]}
          value={
            formData.menstruation
              ? { value: formData.menstruation, label: formData.menstruation }
              : null
          }
          onChange={handleSelectChange}
          styles={customSelectStyles}
          placeholder="Select Status"
          required
        />
      </div>

      {/* Duration */}
      <div className="mb-3">
        <label className="form-label">How long has menstruation stopped?</label>
        <div className="row">
          <div className="col-8">
            <input
              type="number"
              className="form-control"
              name="how_long_m_stopped"
              placeholder="Enter duration"
              value={formData.how_long_m_stopped}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-4">
            <Select
              name="how_long_m_stopped_unit"
              options={[
                { value: "Month", label: "Month" },
                { value: "Year", label: "Year" },
              ]}
              value={
                formData.how_long_m_stopped_unit
                  ? { value: formData.how_long_m_stopped_unit, label: formData.how_long_m_stopped_unit }
                  : null
              }
              onChange={handleSelectChange}
              styles={customSelectStyles}
            />
          </div>
        </div>
      </div>

      {/* Cause */}
      <div className="mb-3">
        <label className="form-label">What causes menstruation?<span style={{ color: "red" }}>*</span></label>
        <Select
          name="causes_m"
          options={[
            { value: "Occurs naturally", label: "Occurs naturally" },
            { value: "Occurs only with medication (tablets)", label: "Occurs only with medication (tablets)" },
            { value: "Sometimes naturally, sometimes with medication", label: "Sometimes naturally, sometimes with medication" },
            { value: "Other", label: "Other" },
          ]}
          value={
            formData.causes_m
              ? { value: formData.causes_m, label: formData.causes_m }
              : null
          }
          onChange={handleSelectChange}
          styles={customSelectStyles}
          placeholder="Select Cause"
          required
        />
      </div>

      {/* Other */}
      {formData.causes_m === "Other" && (
        <div className="mb-3">
          <label className="form-label">Other Name</label>
          <input
            type="text"
            className="form-control"
            name="other_name"
            placeholder="Please specify other cause"
            value={formData.other_name}
            onChange={handleInputChange}
          />
        </div>
      )}

      {/* Occurrence */}
      <div className="mb-3">
        <label className="form-label">How many days does menstruation occur?<span style={{ color: "red" }}>*</span></label>
        <Select
          name="how_many_days_occur"
          options={[
            { value: "10–15 days", label: "10–15 days" },
            { value: "16–23 days", label: "16–23 days" },
            { value: "24–28 days", label: "24–28 days" },
            { value: "28–30 days", label: "28–30 days" },
            { value: "31–45 days", label: "31–45 days" },
            { value: "Every 45 days", label: "Every 45 days" },
            { value: "Every 2 months", label: "Every 2 months" },
            { value: "More than 2 months", label: "More than 2 months" },
            { value: "Cannot say", label: "Cannot say" },
            { value: "Sometimes early, sometimes late", label: "Sometimes early, sometimes late" },
          ]}
          value={
            formData.how_many_days_occur
              ? { value: formData.how_many_days_occur, label: formData.how_many_days_occur }
              : null
          }
          onChange={handleSelectChange}
          styles={customSelectStyles}
          placeholder="Select Duration"
          required
        />
      </div>
    </div>
  );
};

export default MenopauseFormFields;
